export var SiteMemberPrivacyStatus;
(function (SiteMemberPrivacyStatus) {
    SiteMemberPrivacyStatus["UNDEFINED"] = "UNDEFINED";
    SiteMemberPrivacyStatus["PUBLIC"] = "PUBLIC";
    SiteMemberPrivacyStatus["PRIVATE"] = "PRIVATE";
    SiteMemberPrivacyStatus["COMMUNITY"] = "COMMUNITY";
})(SiteMemberPrivacyStatus || (SiteMemberPrivacyStatus = {}));
export var SiteMemberStatus;
(function (SiteMemberStatus) {
    SiteMemberStatus["UNDEFINED_STATUS"] = "UNDEFINED_STATUS";
    SiteMemberStatus["APPLICANT"] = "APPLICANT";
    SiteMemberStatus["ACTIVE"] = "ACTIVE";
    SiteMemberStatus["INACTIVE"] = "INACTIVE";
    SiteMemberStatus["BLOCKED"] = "BLOCKED";
    SiteMemberStatus["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(SiteMemberStatus || (SiteMemberStatus = {}));
export var aSiteMember = {
    id: '1',
    emailVerified: true,
    role: 'MEMBER',
    loginEmail: 'sitemember@wix.com',
    imageUrl: '',
    nickname: 'name',
    profilePrivacyStatus: SiteMemberPrivacyStatus.PUBLIC,
    slug: '',
    language: '',
    status: SiteMemberStatus.ACTIVE,
    creationDate: '',
    lastUpdateDate: '',
    lastLoginDate: '',
};
//# sourceMappingURL=SiteMember.js.map